






































import { Vue } from "vue-property-decorator";
import NumberInput from "./NumberInput.vue";
import StringInput from "./StringInput.vue";

export default Vue.component("StarterInput", {
  computed: {
    showProtein() {
      return this.$store.state.bread.useProteinTarget;
    },
    starter() {
      return this.$store.state.bread.starter;
    },
  },
  methods: {
    updateName(name: string) {
      this.$store.commit("setStarterName", name);
    },
    updateHydration(hydration: number) {
      this.$store.commit("setStarterHydration", hydration);
    },
    updateProtein(protein: number) {
      this.$store.commit("setStarterProtein", protein);
    },
  },
  components: {
    NumberInput,
    StringInput,
  },
});
